import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const EnsureFacilityId: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const facilityId = sessionStorage.getItem("facilityId");

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    if (!queryParams.get("id") && facilityId) {
      queryParams.set("id", facilityId);
      navigate(`${location.pathname}?${queryParams.toString()}`, { replace: true });
    }
  }, [location, facilityId, navigate]);

  return <>{children}</>;
};

export default EnsureFacilityId;
